import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Qs from 'qs'
import Cookies from 'js-cookie'
import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);
Vue.config.productionTip = false;
Vue.prototype.$qs = Qs;
Vue.prototype.$cookie = Cookies;
Vue.prototype.$bus = new Vue;
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#main');